import {QUERY_KEYS, queryClient} from '@/queryClient.ts'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {ErrorResponseData} from '@/types/commons.ts'
import {errorHandler} from '@utilities/genericErrorHandler.ts'
import {raise} from '@utilities/helpers.ts'
import {httpEditFormTicket} from '@/features/tickets/services/tickets.http.ts'
import {HttpEditFormTicketParams} from '@/features/tickets/types.ts'

export const useEditTicketForm = (
    ticketId?: number,
    options?: Omit<UseMutationOptions<unknown, unknown, HttpEditFormTicketParams['data']>, 'mutationFn'>
) => {
    return useMutation({
        ...options,
        mutationFn: data => httpEditFormTicket({ticketId: ticketId || raise('ticketID is undefined'), data}),
        onError: (error: AxiosError<ErrorResponseData>) => {
            errorHandler(error)
        },
        onSuccess: async (data, variables, context) => {
            await queryClient.invalidateQueries({queryKey: [QUERY_KEYS.TICKETS]})
            await queryClient.invalidateQueries({queryKey: [QUERY_KEYS.TICKET_DETAILS, ticketId]})
            options?.onSuccess?.(data, variables, context)
        }
    })
}
